import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaTipoUsuarioMovil(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-usuario-movil/obtener-lista-tipo-usuario-movil",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("YYYY/MM/DD HH:mm");
                    data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.codigo + " - " + item.descripcion,
                        puedeHacerGestionEstregeRecogoProductos: item.puedeHacerGestionEstregeRecogoProductos,
                        esChofer: item.esChofer,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaTipoUsuarioMovil err");
        console.log(err);
        return [];
    }
}

export async function crearTipoUsuarioMovil(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-usuario-movil/crear-tipo-usuario-movil",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearTipoUsuarioMovil err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarTipoUsuarioMovil(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-usuario-movil/actualizar-tipo-usuario-movil",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarTipoUsuarioMovil err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarTipoUsuarioMovil(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-usuario-movil/deshabilitar-tipo-usuario-movil",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarTipoUsuarioMovil err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarTipoUsuarioMovil(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-usuario-movil/habilitar-tipo-usuario-movil",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarTipoUsuarioMovil err");
        console.log(err);
        return { error: true, message: err };
    }
}